import { eventBus, EVENTS } from './EventBus.js';
import Utils from './utils.js';

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  const template = data.template;
  // console.log(template);
  if (data && data.content && data.content.id && data.content.category) {
    setPostView(data);
  }
  getUser(true).then(_user =>{
    if (data && data.content && data.content.id && data.content.category) {
      const postData={
        category: data.content.category,
        date: data.content.date,
        image:data.content.image,
        link: data.content.link,
        slug: data.content.slug,
        time: data.content.time,
        title: data.content.title
      };
      setUserView('post',data.content.id, _user.userid, postData);
    }
  })
});
function getUser(sendAutoLoginEvent=false){
  return new Promise((resolve,reject)=>{
    let isLogged=user.checkUser((_user)=>{
      resolve(_user);
    },null,sendAutoLoginEvent);
    if(!isLogged){
      let _user=Utils.getCookie('user');
      if(!_user){
        _user={
          userid:randomUid()
        }
        Utils.setCookie('rds_user_f', _user, 365);
        resolve(_user);
      }
    }
  });
}
eventBus.on(EVENTS.PLAYER_PODCAST_NEW_SONG, function(s){

  if(s.doNotTrackEvent){
    return;
  }

  const songData={
    categoria: s.categoria,
    giorno: s.giorno,
    immagine: s.immagine,
    master_id: s.master_id,
    titolo: s.titolo,
    audioSrc:s.audioSrc,
    slug:s.slug,
    catSlug:s.category_slug
  };


  if(s.type=='podcast'){
    setPodcastView({
      post_id: s.id, audioSrc: s.audioSrc, additionalData: songData
   });
  }

  getUser().then(_user =>{
    setUserView(s.type, s.id, _user.userid, songData);
  });
});

function setPostView(data) {
  try {
    if (data.content.id) {
      $.ajax({
        type: 'POST',
        url: "https://0qo5sovlje.execute-api.eu-west-1.amazonaws.com/dev/view",
        data: JSON.stringify({ post_id: data.content.id, slug: data.content.slug, env: 'test' }),
        dataType: 'json'
      });
    }
  } catch (e) {
    console.warn(e);
  }
}
function setPodcastView(data) {
  try {
    if (data.post_id) {
      $.ajax({
        type: 'POST',
        url: "https://0qo5sovlje.execute-api.eu-west-1.amazonaws.com/dev/viewPodcast",
        data: JSON.stringify(
          { post_id: data.post_id,
            audioSrc: data.audioSrc,
            additionalData:data.additionalData,
            env: 'test'
          }),
        dataType: 'json'
      });
    }
  } catch (e) {
    console.warn(e);
  }
}

function setUserView(type,id,userId,additionalData) {
  const item={
    userId: userId,
    type: type,
    id: id
  }
  if(additionalData){
    item.additionalData=additionalData;
  }
  try {
    $.ajax({
      type: 'POST',
      url: 'https://0qo5sovlje.execute-api.eu-west-1.amazonaws.com/dev/view/user/',
      data: JSON.stringify(item),
      dataType: 'json',
    });
  } catch (e) {
    console.warn(e);

  }
}
function randomUid() {
  return Math.round(Math.random() * 1000000000000);
}
window.setUserView=setUserView;
